// https://vuetmp.vuejs.org/en/mutations.html

export default {
  loadStatisticsSuccess: (state, payload) => {
    state.statistics = payload;
    state.statistics.loaded = true;
  },
  loadInfluencedOrdersSuccess: ({ influencedOrders }, payload) => {
    influencedOrders.items = payload.data;
    influencedOrders.pagination.totalItems = payload.recordsTotal;
  },
  setPagination({ influencedOrders }, payload) {
    influencedOrders.pagination = payload;
  },
  loadCouponInfluencedOrdersSuccess: ({ couponInfluencedOrders }, payload) => {
    couponInfluencedOrders.items = payload.data;
    couponInfluencedOrders.pagination.totalItems = payload.recordsTotal;
    couponInfluencedOrders.couponsTotal = payload.couponsTotal;
    couponInfluencedOrders.totalPaid = payload.totalPaid;
  },
  setCouponPagination({ couponInfluencedOrders }, payload) {
    couponInfluencedOrders.pagination = payload;
  },
  loadReviewsPerPeriodSuccess({ reviewsPerPeriod }, payload) {
    reviewsPerPeriod.items = payload;
  },
  loadReviewRequestsMonthlyStatsSuccess: ({ reviewRequestsMonthlyStats }, payload) => {
    reviewRequestsMonthlyStats.items = payload;
  },
  ////////////////
  loadDailyInfluencedOrderStatsSuccess: (state, payload) => {
    state.dailyInfluencedOrderStats = payload;
  },
  setStatsLoaded: (state, payload) => {
    state.dailyReviewStats.loaded = payload;
  },
  loadDailyReviewStatsSuccess: (state, payload) => {
    state.dailyReviewStats = { ...payload };
    state.dailyReviewStats.loaded = true;
  },
  loadDailyCouponInfluencedStatsSuccess: (state, payload) => {
    state.dailyCouponInfluencedStats = payload;
  },
  loadDailyReviewRequestStatsSuccess: (state, payload) => {
    state.dailyReviewRequestStats = payload;
  },
  loadDailyCouponStatsSuccess: (state, payload) => {
    state.dailyCouponStats = payload;
  },
};
